import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M20 7h-9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 17H5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "17", cy: "17", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "7", cy: "7", r: "3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Settings2";
const Settings2 = memo(themed(Icon));
export {
  Settings2
};
//# sourceMappingURL=settings-2.js.map
